import { render, staticRenderFns } from "./AddressSetup.vue?vue&type=template&id=7949e68c&scoped=true&lang=pug"
import script from "./AddressSetup.vue?vue&type=script&lang=js"
export * from "./AddressSetup.vue?vue&type=script&lang=js"
import style0 from "./AddressSetup.vue?vue&type=style&index=0&id=7949e68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7949e68c",
  null
  
)

export default component.exports